import apiClient, { SilentAuthError } from '../services/apiClient';

/**
 * 通用API请求函数（兼容性封装）
 * @param {string} method - HTTP方法 (GET, POST, PUT, DELETE)
 * @param {string} url - API路径
 * @param {object} data - 请求数据（可选）
 * @param {object} config - 额外的axios配置（可选）
 * @returns {Promise} API响应
 */
export const apiRequest = async (method, url, data = null, config = {}) => {
    try {
        let response;

        switch (method.toUpperCase()) {
            case 'GET':
                response = await apiClient.get(url, {
                    params: data,
                    ...config
                });
                break;
            case 'POST':
                response = await apiClient.post(url, data, config);
                break;
            case 'PUT':
                response = await apiClient.put(url, data, config);
                break;
            case 'DELETE':
                response = await apiClient.delete(url, {
                    data,
                    ...config
                });
                break;
            default:
                throw new Error(`Unsupported HTTP method: ${method}`);
        }

        return response.data;
    } catch (error) {
        // 如果是静默认证错误（401已处理），不抛出错误
        if (error instanceof SilentAuthError || error?.isSilent) {
            // 返回一个表示认证失败的响应，但不触发错误提示
            return { success: false, error: 'Unauthorized', silent: true };
        }
        // 如果有响应错误，抛出响应数据，否则抛出错误本身
        throw error.response?.data || error;
    }
};

export default apiRequest;
